import { Component, OnInit, Input } from '@angular/core';
import { FieldModel } from './field.model';
import { FormyService } from '../formy.service';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.css'],
  providers: [FormyService]
})
export class FieldComponent implements OnInit {
  @Input() model: FieldModel;
  @Input() validation: boolean;
  
  service: FormyService;

  constructor(private formyService: FormyService) {
    this.service = formyService;

  }

  ngOnInit() {}

  grd(siz:number){
    return this.service.grd(siz);
  }
}
